import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ClTypography from '../ClTypography/ClTypography.vue';
import { ColorType } from '../types';

@Component({ components: { ClTypography } })
export default class ClFormHelperText extends Vue {
  @Prop(Boolean)
  public error!: boolean;

  @Prop({
    type: String as () => ColorType,
    default: 'default'
  })
  public color!: ColorType;

  public activeColor: ColorType = this.error ? 'error' : this.color;

  @Watch('error')
  public setErrorColor() {
    this.activeColor = 'error';
  }
}
